import {MouseEvent, useCallback} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';
import {LOG_SEARCH_CLICK} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {PcRecentSearchesItemProps} from './PcRecentSearchesItemProps.interface';

export function PcRecentSearchesItem({
  keyword,
  createdAt,
  index,
  onClickKeyword,
  onClickRemoveButton,
  searchUrl,
  className,
  ...props
}: PcRecentSearchesItemProps) {
  const handleClickRemoveButton = useCallback(
    (event: MouseEvent<HTMLButtonElement>, keyword: string) => {
      event.stopPropagation();
      onClickRemoveButton(keyword);
    },
    [onClickRemoveButton]
  );
  return (
    <div
      className={twMerge(
        'flex h-34pxr cursor-pointer items-center px-8pxr hover:rounded-4pxr hover:bg-theme-solid-10',
        className
      )}
      onClick={event =>
        LOG_SEARCH_CLICK('최근검색어_클릭', event, () =>
          onClickKeyword(keyword)
        )
      }
      {...props}
      {...putTiaraObjectProps({
        actionKind: 'Search',
        click: {
          ordnum: String(index + 1),
          copy: keyword,
        },
        search: {
          search_term: keyword,
          search_type: '최근검색어',
        },
      })}
    >
      <UrlLink url={searchUrl} linkClassName="flex-1 flex items-center">
        <Text className="font-small1 flex-1 break-all text-theme-solid-100 line-clamp-1">
          {keyword}
        </Text>
        <Text className="font-small2 mr-8pxr shrink-0 text-theme-solid-40">
          {createdAt}
        </Text>
      </UrlLink>
      <button
        type="button"
        className="shrink-0"
        onClick={event => {
          LOG_SEARCH_CLICK('최근검색어_삭제_클릭', event, () =>
            handleClickRemoveButton(event, keyword)
          );
        }}
      >
        <Icon type={IconType.ButtonCloseS} />
      </button>
    </div>
  );
}
